* {
  box-sizing: border-box;
}

.container {
  padding: calc(2 * var(--spacer)) calc(2 * var(--spacer)) calc(2 * var(--spacer)) calc(5 * var(--spacer));

  .form-subtitle {
    color: var(--main-titles-inputs-600);
    line-height: 22px;
    padding: 5px 0 5px 0;
    cursor: context-menu;
  }

  gz-title {
    color: var(--chart-300-icon-buttons);
    line-height: 17px;
    padding: var(--spacer) 0 var(--spacer) 0;
    cursor: context-menu;
  }

  #general-section {
    margin-bottom: calc(var(--spacer) * 4);
    gz-form-field {
      padding: var(--spacer) 0;
    }
  }

  #scan-targets-checkbox-group,
  #scan-restrictions-checkbox-group {
    gz-form-field {
      padding: 6px 0;
      margin: var(--spacer) 0;
    }
  }

  gz-form-field {
    --margin-bottom-wrapper: 0;
    line-height: 20px;
    padding: 6px 0;
    &::part(form-field-label) {
      cursor: context-menu;
    }
  }

  gz-form-field-toggleable {
    &::part(toggle-label) {
      &:after {
        content: '';
      }
    }
  }

  gz-form-field {
    &::part(form-field-label) {
      &:after {
        content: '';
      }
    }
  }

  gz-input-number-with-dropdown {
    display: flex;
    gap: var(--spacer);
    max-width: 240px;
    --dropdown-width: 80px;
  }

  #grid-header {
    display: flex;
    gz-form-field,
    #add-exclusion-button {
      padding-top: calc(var(--spacer) * 2);
    }
  }

  #exclusion-section {
    overflow-x: clip;
    gz-text {
      padding: calc(var(--spacer) * 2) 0 calc(var(--spacer) + 2px) 0;
    }
    gz-light-grid {
      max-width: 620px;
      min-width: 620px;
      margin-left: -20px;
    }

    gz-light-grid::part(light-grid) {
      --_lumo-grid-border-color: var(--chart-101-pressed-dividers);
      --_lumo-grid-secondary-border-color: var(--chart-101-pressed-dividers);
    }

    gz-light-grid {
      --grid-border-color: var(--chart-101-pressed-dividers);
      --grid-border-width: 1px;
    }

    gz-light-grid[items='[]'] {
      --grid-border-color: transparent;
      border-bottom: 1px solid var(--chart-101-pressed-dividers);
    }
  }

  #scan-for-pua-checkbox {
    max-width: 250px;
  }

  #actions-section {
    gz-form-field {
      padding: 0;
    }
  }

  gz-chips-generator-input {
    --chip-list-width: 480px;
    --form-field-with-floating-max-width: 480px;
  }

  gz-form-field,
  gz-form-field-toggleable {
    --form-field-label-width: 280px;
  }

  gz-checkbox {
    width: auto;
  }

  #exclusion-section {
    .empty-state-grid {
      border-bottom: 1px solid var(--chart-101-pressed-dividers);
      width: 600px;
      padding: calc(var(--spacer) / 2) var(--spacer) var(--spacer) 0;
    }
  }

  gz-single-select:focus-within {
    --dropdown-border-right: 1px solid var(--blue-layout-500-focus);
    --dropdown-border-left: 1px solid var(--blue-layout-500-focus);
    --dropdown-border-bottom: 1px solid var(--blue-layout-500-focus);
    --dropdown-border-top: 1px solid var(--blue-layout-500-focus);
  }
}
